import { LOGIN_ROUTES } from '@/shared/routes/paths';

export const SIGN_IN_HREF: string = LOGIN_ROUTES.ROOT;

export const DEFAULT_TITLE = 'Explore the ThredUp Client Portal';
export const DEFAULT_SUBTITLE =
  'Everything you need to manage and grow your resale program — all in one place.';

export const LABELS = {
  email: 'Work email',
  company: 'Company name',
  colleague: "Colleague's work email"
} as const;

export const PLACEHOLDERS = {
  email: 'you@yourcompany.com',
  company: 'Your company name',
  colleague: 'colleague@yourcompany.com'
} as const;

export const EMAIL_HELPER =
  'Use your company email so we can verify your organization.';

export const TOGGLE_LABELS = {
  add: 'Add a colleague to this request',
  remove: 'Remove colleague'
} as const;

export const SUBMIT_LABEL = 'Request access';
export const SIGN_IN_LABEL = 'Already have an account? Sign in here';
export const SUCCESS_SIGN_IN_LABEL = 'Already onboarded? Sign in';
export const SUCCESS_TITLE = 'Request received.';

// Now the portal's own internal legal pages (admin-editable), replacing the
// off-site thredup.com links.
export const LEGAL_LINKS = {
  terms: '/legal/terms-of-use',
  privacy: '/legal/privacy'
} as const;

export const GENERIC_ERROR = 'Something went wrong. Please try again.';

// Bot verification (Cloudflare Turnstile). The widget owns its own visuals; this
// is only the surrounding copy. A verification failure the SERVER reports needs
// no copy here — b2b-api returns it in the RFC-7807 `detail`, which the form
// already renders verbatim.
export const TURNSTILE_LABEL = 'Verification';
export const TURNSTILE_PENDING_HINT =
  'Verifying that you’re human — this only takes a moment.';
export const TURNSTILE_ERROR =
  'We couldn’t verify you. Try again, or refresh the page.';
export const TURNSTILE_RETRY_LABEL = 'Try verification again';

// `provisioned: false` now means exactly one thing: auto-provisioning didn't
// complete and the request is in the manual approval queue. So this copy must
// keep promising a human, and must NOT promise an invitation email.
export const buildSuccessMessage = (
  companyName: string,
  hasColleague: boolean
): string =>
  `Thanks — we'll verify ${companyName} and email you${
    hasColleague ? ' and your colleague' : ''
  } an invite to the Client Portal within one business day.`;

// The auto-provisioned path: the organization exists and the invitation has
// already been accepted by WorkOS, so there is nothing to wait on but the inbox.
export const buildProvisionedMessage = (
  companyName: string,
  hasColleague: boolean
): string =>
  `${companyName} is all set up. You should receive an invitation email to access the Client Portal${
    hasColleague ? ', and so should your colleague' : ''
  }.`;
